import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      style={{
        background:
          "linear-gradient(135deg, #020617 0%, #0f172a 45%, #111827 100%)",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        position: "relative",
        overflow: "hidden"
      }}
    >
      {/* Glow Effects */}
      <div
        style={{
          position: "absolute",
          top: "-80px",
          left: "-80px",
          width: "220px",
          height: "220px",
          background: "rgba(56,189,248,0.08)",
          filter: "blur(90px)",
          borderRadius: "50%"
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-80px",
          right: "-80px",
          width: "240px",
          height: "240px",
          background: "rgba(34,197,94,0.08)",
          filter: "blur(90px)",
          borderRadius: "50%"
        }}
      />

      <div className="container py-5 position-relative">
        <div className="row g-4 align-items-start">
          {/* Brand */}
          <div className="col-lg-5">
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "18px"
              }}
            >
              <div
                style={{
                  width: "52px",
                  height: "52px",
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background:
                    "linear-gradient(135deg, rgba(56,189,248,0.18), rgba(34,197,94,0.16))",
                  border: "1px solid rgba(255,255,255,0.08)",
                  fontSize: "1.5rem"
                }}
              >
                🎯
              </div>

              <div>
                <h4
                  style={{
                    margin: 0,
                    color: "#f8fafc",
                    fontWeight: 900,
                    letterSpacing: "0.3px"
                  }}
                >
                  UPSC Titan Score
                </h4>
                <p
                  style={{
                    margin: 0,
                    color: "#94a3b8",
                    fontSize: "0.92rem"
                  }}
                >
                  Premium UPSC Preparation Platform
                </p>
              </div>
            </div>

            <p
              style={{
                color: "#cbd5e1",
                lineHeight: "1.9",
                fontSize: "0.97rem",
                maxWidth: "520px",
                marginBottom: "18px"
              }}
            >
              Structured UPSC preparation with premium current affairs, question
              banks, mock exams, notes, AI support and topic-wise learning
              designed for serious aspirants.
            </p>

            <div className="d-flex flex-wrap gap-2">
              <span style={pillStyle}>UPSC Focused</span>
              <span style={pillStyle}>Premium Content</span>
              <span style={pillStyle}>Weekly Access</span>
              <span style={pillStyle}>AI Assisted</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6 style={headingStyle}>Quick Links</h6>
            <div className="d-flex flex-column gap-2">
              <Link to="/" style={footerLinkStyle}>Home</Link>
              <Link to="/about" style={footerLinkStyle}>About</Link>
              <Link to="/login" style={footerLinkStyle}>Login</Link>
              <Link to="/register" style={footerLinkStyle}>Register</Link>
              <Link to="/subscription" style={footerLinkStyle}>Premium</Link>
            </div>
          </div>

          {/* Legal */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6 style={headingStyle}>Legal</h6>
            <div className="d-flex flex-column gap-2">
              <Link to="/privacy" style={footerLinkStyle}>Privacy Policy</Link>
              <Link to="/terms" style={footerLinkStyle}>Terms & Conditions</Link>
              <Link to="/disclaimer" style={footerLinkStyle}>Disclaimer</Link>
              <Link to="/about" style={footerLinkStyle}>Company Info</Link>
            </div>
          </div>

          {/* Social + Trust */}
          <div className="col-lg-3">
            <h6 style={headingStyle}>Connect With Us</h6>

            <div className="d-flex flex-wrap gap-2 mb-4">
              <a
                href="https://whatsapp.com/channel/0029Vb7Idcu2ZjCmWn5tGe0b"
                target="_blank"
                rel="noreferrer"
                style={socialBtnStyle}
              >
                💬 Whatsapp
              </a>

              <a
                href="https://youtube.com/@drankmatrix?si=_-AfBkxlfOfRlrOe"
                target="_blank"
                rel="noreferrer"
                style={socialBtnStyle}
              >
                ▶️ YouTube
              </a>

              <a
                href="https://t.me/DRankMatrix"
                target="_blank"
                rel="noreferrer"
                style={socialBtnStyle}
              >
                ✈️ Telegram
              </a>

              <a
                href="https://www.facebook.com/profile.php?id=61585561690017"
                target="_blank"
                rel="noreferrer"
                style={socialBtnStyle}
              >
                👍 Facebook
              </a>

              <a
                href="https://x.com/"
                target="_blank"
                rel="noreferrer"
                style={socialBtnStyle}
              >
                𝕏 Twitter
              </a>

              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noreferrer"
                style={socialBtnStyle}
              >
                💼 LinkedIn
              </a>
            </div>

            <div
              style={{
                padding: "16px 18px",
                borderRadius: "18px",
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.08)"
              }}
            >
              <div
                style={{
                  color: "#22c55e",
                  fontWeight: 800,
                  marginBottom: "6px"
                }}
              >
                Trusted UPSC Preparation
              </div>
              <p
                style={{
                  color: "#cbd5e1",
                  fontSize: "0.92rem",
                  marginBottom: 0,
                  lineHeight: "1.7"
                }}
              >
                Built to make premium learning feel structured, valuable and
                simple to follow for every aspirant.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div
          className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-5 pt-4"
          style={{
            borderTop: "1px solid rgba(255,255,255,0.08)"
          }}
        >
          <p
            style={{
              color: "#94a3b8",
              marginBottom: "10px",
              fontSize: "0.92rem"
            }}
          >
            © 2026 UPSC Titan Score. All rights reserved.
          </p>

          <p
            style={{
              color: "#64748b",
              marginBottom: 0,
              fontSize: "0.88rem",
              textAlign: "center"
            }}
          >
            Designed for serious UPSC aspirants with modern premium learning.
          </p>
        </div>
      </div>
    </footer>
  );
}

/* ================= STYLES ================= */
const headingStyle = {
  color: "#f8fafc",
  fontWeight: 800,
  marginBottom: "16px",
  fontSize: "1rem"
};

const footerLinkStyle = {
  color: "#cbd5e1",
  textDecoration: "none",
  fontSize: "0.95rem",
  transition: "0.25s ease"
};

const socialBtnStyle = {
  textDecoration: "none",
  color: "#f8fafc",
  padding: "10px 14px",
  borderRadius: "14px",
  background: "rgba(255,255,255,0.05)",
  border: "1px solid rgba(255,255,255,0.08)",
  fontSize: "0.9rem",
  fontWeight: 700
};

const pillStyle = {
  padding: "8px 14px",
  borderRadius: "999px",
  background: "rgba(56,189,248,0.10)",
  border: "1px solid rgba(56,189,248,0.18)",
  color: "#7dd3fc",
  fontSize: "0.82rem",
  fontWeight: 700
};

